










































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import LoadingIndicator from '@/components/LoadingIndicator'
import Timeline from '@modules/ui/components/Timeline'

GROUP_SEPARATOR = ' › '
ORPHAN_TITLE = 'Platform'

settings =
  name: 'StatusCheckShow'

  vue:
    components: {
      LoadingIndicator,
      Timeline,
    }

    data: ->
      statusChecksData: null
      selectedGroupName: @$route.query.filter

    computed:
      statusChecks: ->
        items = []
        items.push { key: key.replace(/^status\.ok\./, ''), ...item } for key, item of (@statusChecksData?.items?.status || {})
        items

      selectedNamespace: ->
        @formatGroupNameToNamespace @selectedGroupName

      filteredStatusChecks: ->
        # no filter selected
        return @statusChecks unless @selectedGroupName
        # checks without namespace selected in the filter
        return @statusChecks.filter((item) => !item.key.includes('.')) if @selectedGroupName is ORPHAN_TITLE
        # any filter selected
        @statusChecks.filter((item) => item.key.startsWith(@selectedNamespace))

      okStatusChecks: ->
        @filteredStatusChecks.filter((item) => item.ok)

      errorStatusChecks: ->
        @filteredStatusChecks.filter((item) => !item.ok)

      lastStatusCheck: ->
        @filteredStatusChecks.sort((a, b) => dayjs(b.timestamp).diff(a.timestamp))[0]

      incidents: ->
        @statusChecksData?.items?.incident_registers || []

      filteredIncidents: ->
        # no filter selected
        return @incidents unless @selectedGroupName
        # checks without namespace selected in the filter
        return @incidents.filter((item) => item.length is 1) if @selectedGroupName is ORPHAN_TITLE
        # any filter selected
        @incidents.filter((item) => item.namespace.join('.').startsWith(@selectedNamespace))

      summary: ->
        fromNow = @formatTimeFromNow @lastStatusCheck?.timestamp
        errorsCount = @errorStatusChecks.length
        return "Everything checks out OK (as of #{fromNow})" if errorsCount is 0
        "#{errorsCount} errors detected (as of #{fromNow})"

      groups: ->
        groups = {}
        for check in @statusChecks || []
          [groupNames..., title] = check.key.split '.'
          title = @$options.filters.formatTitle title
          groupName = @formatNamespace groupNames
          groups[groupName] ||= []
          groups[groupName].push { title, ...check }

        groupNames = Object.keys(groups).sort(@groupSorter)
        sortedGroups = {}
        sortedGroups[groupName] = groups[groupName].sort(@checkSorter) for groupName in groupNames
        sortedGroups

      groupNames: ->
        names = Object.keys @groups
        for name in names
          tokens = name.split GROUP_SEPARATOR
          while tokens.length
            parent = tokens.join GROUP_SEPARATOR
            names.push parent unless parent in names
            tokens.pop()
        names.sort @groupSorter

    mounted: ->
      @fetchStatusChecks()

    methods:
      fetchStatusChecks: ->
        { data } = await RecessAPI.get 'api/v2/open/status_check_service'
        @statusChecksData = data

      hiChangeSelectedGroupName: (groupName) ->
        { ...query, filter } = @$route.query
        query.filter = groupName if groupName
        @$router.replace { query }

      shouldDisplayGroup: (groupName) ->
        return groupName.startsWith @selectedGroupName if @selectedGroupName
        true

      groupSorter: (groupNameA, groupNameB) ->
        if groupNameA is groupNameB
          return 0
        else if groupNameA is ORPHAN_TITLE
          return 1
        else if groupNameB is ORPHAN_TITLE
          return -1
        else
          return groupNameA.localeCompare(groupNameB)

      checkSorter: (checkA, checkB) ->
        if checkA.ok is checkB.ok
          return checkA.title.localeCompare checkB.title
        else if checkA.ok
          return 1
        else
          return -1

      formatNamespace: (namespace) ->
        title = namespace.map @$options.filters.formatTitle
        title.join(GROUP_SEPARATOR) || ORPHAN_TITLE

      formatGroupNameToNamespace: (groupName) ->
        groupName
          .replaceAll GROUP_SEPARATOR, '.'
          .replaceAll ' ', '_'
          .toLowerCase()

      formatTimeFromNow: (timestamp) ->
        dayjs(timestamp).fromNow()

      formatTimestampTooltip: (timestamp) ->
        dayjs(timestamp).format()

export default VueOptions.vue settings
